import React from "react";
import "./Square.css";

const Square = ({ children }) => {
  return (
    <div className="square">
      <div className="content">{children}</div>
    </div>
  );
};

export default Square;
